import { c as _c } from "react/compiler-runtime";
import { InfoTooltip } from '@repo/ui/composites/InfoTooltip';
import { Typography } from '@repo/ui/Typography';
import type { StarRatingTooltipProps, TooltipActionType } from './types';
type StarRatingTooltipContentProps = StarRatingTooltipProps & {
  position?: 'top' | 'bottom' | 'left' | 'right';
  handleTooltipClickPageAction: (actionType: TooltipActionType, actionSection: string) => void;
};
export function StarRatingTooltipContent(t0) {
  const $ = _c(10);
  const {
    position: t1,
    popupCss,
    segmentActionSection,
    handleTooltipClickPageAction
  } = t0;
  const position = t1 === undefined ? "bottom" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography css={{
      p: "1",
      pb: "0",
      color: "grey.500",
      textStyle: "text.small",
      _pcMd: {
        color: "common.black",
        pb: "3",
        textStyle: "body"
      }
    }}>NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account the type of card being reviewed (such as cash back, travel or balance transfer) and the card's rates, fees, rewards and other features.</Typography>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const text = t2;
  let t3;
  let t4;
  if ($[1] !== handleTooltipClickPageAction || $[2] !== segmentActionSection) {
    t3 = () => handleTooltipClickPageAction("open", segmentActionSection || "");
    t4 = () => handleTooltipClickPageAction("close", segmentActionSection || "");
    $[1] = handleTooltipClickPageAction;
    $[2] = segmentActionSection;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== popupCss || $[6] !== position || $[7] !== t3 || $[8] !== t4) {
    t5 = <InfoTooltip ariaLabel="How are NerdWallet's ratings determined?" text={text} position={position} popupCss={popupCss} onOpen={t3} onClose={t4} />;
    $[5] = popupCss;
    $[6] = position;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}